var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"administration-costs-container"},[_c('InJourneyAccordion',{attrs:{"accordionData":_vm.accordionData,"summarySection":_vm.summarySection,"padding":_vm.padding},on:{"summaryClicked":_vm.summaryClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }